import IconButton from '@savvy-kit/components/icon-button';
import { Text } from '@savvy-kit/foundations/text';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import { PageSizeSelect } from '../../pagination/page-size-select';
import { useClientsPagination } from './clients-pagination-context';

export function PaginationTableFooter() {
  const {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    totalItems,
    hasNextPage,
    hasPreviousPage,
    goToNextPage,
    goToPreviousPage,
  } = useClientsPagination();

  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  const handlePreviousPage = () => {
    if (hasPreviousPage) {
      goToPreviousPage();
    }
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      goToNextPage();
    }
  };

  return (
    <div className="flex flex-row gap-4 items-center justify-end p-2 border-t border-t-border-light">
      <Text variant="caption" color="secondary">
        Rows per page:
      </Text>
      <PageSizeSelect
        value={pageSize}
        onChange={(size) => {
          setPageSize(size);
          setCurrentPage(1);
        }}
      />
      <div className="flex flex-row gap-2 items-center">
        <Text variant="caption" color="secondary">
          {totalItems > 0 ? `${startItem}-${endItem} of ${totalItems}` : '0 of 0'}
        </Text>
        <IconButton
          variant="ghost"
          size="sm"
          aria-label="Previous page"
          onClick={handlePreviousPage}
          disabled={!hasPreviousPage}
        >
          <ChevronLeft />
        </IconButton>
        <IconButton variant="ghost" size="sm" aria-label="Next page" onClick={handleNextPage} disabled={!hasNextPage}>
          <ChevronRight />
        </IconButton>
      </div>
    </div>
  );
}
